// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-dashboard .navbar {
  margin-left: 16.3%;
  width: auto;
}

.user-dashboard header h1 {
  font-size: 16px;
  color: #060d27;
  text-transform: capitalize;
  letter-spacing: 4px;
}

.user-dashboard .avatar {
  height: 35px;
  width: 35px;
  border-radius: 50%;
}

.user-dashboard .user .profile-pic {
  height: 40px;
  width: 40px;
  border-radius: 50%;
  margin-right: 10px;
}

.user-dashboard .initials-avatar {
  margin-right: 10px;
}

.user-dashboard .notification {
  border-right: 1px solid #e6e4e4;
  padding-right: 10px;
}

.user-dashboard .notification img {
  height: 20px;
  width: 20px;
  margin-top: 6px;
}

.user-dashboard .user-menu {
  position: absolute;
  background-color: #ffffff;
  right: 30px;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #f4f4f4;
  top: 55px;
  width: 180px;
}

.user-dashboard .hide {
  display: none;
}

.user-dashboard .user-info {
  padding: 10px;
  border-bottom: 1px solid #dbdbdb;
}

.user-dashboard .user-info h4 {
  font-weight: 600;
  color: #000000;
  font-size: 12px;
  margin-bottom: 0;
}

.user-dashboard .user-info p {
  margin: 0;
  letter-spacing: 0.63px;
  color: #a0a0a0;
  text-transform: capitalize;
  font-size: 12px;
}

.user-dashboard .user-menu ul {
  padding: 10px;
  list-style: none;
  margin-bottom: 0;
  font-size: 14px;
}

.user-dashboard .user-menu a {
  color: #3482f2;
  text-decoration: none;
  font-weight: 400;
}

.user-dashboard .user-menu .menu-action-btn {
  background-color: transparent;
  border: none;
  color: #3482f2;
  font-weight: 400;
  font-size: 12px;
  padding: 0;
}

.user-dashboard .hide-li {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/view/user-dashboard/header/Header.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,iCAAiC;EACjC,yBAAyB;EACzB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,cAAc;EACd,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,aAAa;AACf","sourcesContent":[".user-dashboard .navbar {\n  margin-left: 16.3%;\n  width: auto;\n}\n\n.user-dashboard header h1 {\n  font-size: 16px;\n  color: #060d27;\n  text-transform: capitalize;\n  letter-spacing: 4px;\n}\n\n.user-dashboard .avatar {\n  height: 35px;\n  width: 35px;\n  border-radius: 50%;\n}\n\n.user-dashboard .user .profile-pic {\n  height: 40px;\n  width: 40px;\n  border-radius: 50%;\n  margin-right: 10px;\n}\n\n.user-dashboard .initials-avatar {\n  margin-right: 10px;\n}\n\n.user-dashboard .notification {\n  border-right: 1px solid #e6e4e4;\n  padding-right: 10px;\n}\n\n.user-dashboard .notification img {\n  height: 20px;\n  width: 20px;\n  margin-top: 6px;\n}\n\n.user-dashboard .user-menu {\n  position: absolute;\n  background-color: #ffffff;\n  right: 30px;\n  box-shadow: 0px 3px 6px #00000029;\n  border: 1px solid #f4f4f4;\n  top: 55px;\n  width: 180px;\n}\n\n.user-dashboard .hide {\n  display: none;\n}\n\n.user-dashboard .user-info {\n  padding: 10px;\n  border-bottom: 1px solid #dbdbdb;\n}\n\n.user-dashboard .user-info h4 {\n  font-weight: 600;\n  color: #000000;\n  font-size: 12px;\n  margin-bottom: 0;\n}\n\n.user-dashboard .user-info p {\n  margin: 0;\n  letter-spacing: 0.63px;\n  color: #a0a0a0;\n  text-transform: capitalize;\n  font-size: 12px;\n}\n\n.user-dashboard .user-menu ul {\n  padding: 10px;\n  list-style: none;\n  margin-bottom: 0;\n  font-size: 14px;\n}\n\n.user-dashboard .user-menu a {\n  color: #3482f2;\n  text-decoration: none;\n  font-weight: 400;\n}\n\n.user-dashboard .user-menu .menu-action-btn {\n  background-color: transparent;\n  border: none;\n  color: #3482f2;\n  font-weight: 400;\n  font-size: 12px;\n  padding: 0;\n}\n\n.user-dashboard .hide-li {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
